<template>
  <div class="select-wrapper" @click="openModal" @focusout="closeModal" :tabindex="99999">
    <div class="selected mt-7">
      <span class="ml-15">{{ selectedOption }}</span>
      <font-awesome-icon class="geo-icon ml-15" :icon="['fas', 'angle-down']"></font-awesome-icon>
    </div>
    <div class="option-wrapper" v-if="isOptionsOpened" >
      <div v-for="(o, i) in options" :key="i" class="option mt-5 pb-10">
        <span @click="selectOption(o.value)" class="ml-15">{{ o.text }}</span>
        <font-awesome-icon v-if="i === 0" class="geo-icon ml-15" :icon="['fas', 'angle-up']"></font-awesome-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class CustomSelect extends Vue {
  selected = 'week'
  isOptionsOpened = false
  options = [
    {
      value: "week",
      text: "Неделя"
    },
    {
      value: "month",
      text: "Месяц"
    },
    // {
    //   value: "day",
    //   text: "День"
    // }
  ];

  get selectedOption() {
    const option = this.options.find(op => op.value === this.selected)
    return option.text || 'Выберите'
  }

  @Watch('selected', { deep: true, immediate: true })
  onSelectedChange() {
    this.closeModal()
  }

  selectOption(value) {
    this.$emit("selected", value);
    this.selected = value
    this.closeModal()
    this.changeOptions(value)
  }

  changeOptions(value) {
    const option = this.options.find(o => o.value === value)
    const newOptions = this.options.filter(o => o.value !== value)
    console.log({ option, newOptions })
    newOptions.unshift(option)
    this.options = newOptions
  }

  openModal() {
    this.isOptionsOpened = true
  }

  closeModal() {
    this.isOptionsOpened = false
  }

  created() {

  }
}
</script>

<style lang="stylus" scoped>
.select-wrapper {
  position: relative
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 29px;
  width: 100px;
  height: 36px;
  color: rgba(51, 51, 51, 0.5);
  

  .select-wrapper {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
  }

  .option-wrapper {
    position: absolute;
    top: 0;
    background: #FFFFFF;
    border-bottom: 1px solid #E0E0E0;
    border-left: 1px solid #E0E0E0;
    border-right: 1px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 18px;
    width: 100px;
    z-index: 10

    .option {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      cursor: pointer;
    }
  }
}
</style>